import type { MaybeRefOrGetter } from "vue";
import { computed, toValue } from "vue";
import { axure } from "./axure";
import { jira } from "./jira";
import { linear } from "./linear";

const matchers = [
  axure,
  jira,
  linear,
] as const;

export function getWellKnownServiceMatch(url: string) {
  for (const matcher of matchers) {
    const match = matcher(url);
    if (match) return match;
  }

  return undefined;
}

export function useWellKnownServiceMatch(url: MaybeRefOrGetter<string>) {
  return computed(() => getWellKnownServiceMatch(toValue(url)));
}
